export default __webpack_public_path__ + "8b1231baf378e165f97ff86af7b25019.svg";